var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSfdr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 16.0033C12.0002 13.7933 13.7918 12.0017 16.0019 12.0017C13.7918 12.0017 12.0002 10.2101 12.0002 8C12.0002 10.2101 10.2086 12.0017 7.99854 12.0017C10.2086 12.0017 12.0002 13.7933 12.0002 16.0033Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9402 8.06109C18.9402 6.40355 20.2839 5.05984 21.9415 5.05984C20.2839 5.05984 18.9402 3.71614 18.9402 2.05859C18.9402 3.71614 17.5965 5.05984 15.939 5.05984C16.7349 5.05984 17.4983 5.37605 18.0612 5.93889C18.624 6.50173 18.9402 7.26511 18.9402 8.06109V8.06109Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0041 10.9994V17.0019C21.0041 19.212 19.2125 21.0036 17.0024 21.0036H6.99825C4.78819 21.0036 2.99658 19.212 2.99658 17.0019V6.99776C2.99658 4.7877 4.78819 2.99609 6.99825 2.99609H13.0007",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfdr);
export default __webpack_public_path__ + "static/media/sfdr.e4dc6ab43e6c916432420ef9cc52778b.svg";
export { ForwardRef as ReactComponent };